import { createContext } from 'react';
import type { PendingLessonUpload } from '../types/lesson';

/** The signed-in person's uploads, from the one subscription (PendingUploadsProvider). */
export const PendingUploadsContext = createContext<PendingLessonUpload[]>([]);
